import { Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthenticationService } from '../../services/common/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CMSContentComponent } from '../../shared/cms-content/cms-content.component';
import {
  StorageKey,
  StorageService,
} from '../../services/common/storage.service';
import { filter } from 'rxjs';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationComponent } from '../../shared/notification/notification/notification.component';
import { LanguageService } from '../../services/languageService/language-service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-front-layout',
  templateUrl: './front-layout.component.html',
  styleUrl: './front-layout.component.scss',
})
export class FrontLayoutComponent implements OnDestroy {
  lang_form!: FormGroup;
  UserType: any;
  isLoggedIn = false;
  isRootUrl = false;
  hideAgentDemoButton = false;
  id: any;
  NotificationList: any;
  notificationCount: number = 0;
  showNotifications: boolean = false;
  private timeoutId: any;
  @ViewChild('notificationPanel') notificationPanel!: ElementRef;

  constructor(
    public router: Router,
    private authService: AuthenticationService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private url: ApiUrlHelper,
    private apiservice: ApiService,
    private spinner: NgxSpinnerService,
    private languageService: LanguageService,
    private translate: TranslateService,
    private toastr : ToastrService
  ) {
    this.translate.setDefaultLang('eng');
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  ngOnInit() {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
      this.selectedLanguage = language;
    });
    this.checkAuthenticationStatus();
    this.checkUrl();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkUrl();
        this.checkAuthenticationStatus();
      });
    if (this.isLoggedIn) {
      this.getNotificationList();
      this.timeoutId = setInterval(() => this.getNotificationList(), 120000);
    }
  }

  selectedLanguage = this.languageService.getLanguage();

  showNotification() {
    this.showNotifications = !this.showNotifications;
  }
  checkAuthenticationStatus() {
    const token = this.storageService.getValue(StorageKey.authToken);
    if (token && this.authService.isTokenValid()) {
      this.isLoggedIn = true;
      this.UserType = this.storageService.getTokenData().UserTypeId;
      this.id = this.storageService.getTokenData().UserId;
    } else {
      this.isLoggedIn = false;
      this.UserType = null;
      if (token && !this.authService.isTokenValid()) {
        this.authService.logout();
      }
    }
  }
  lang_function() {
    // var data = localStorage.getItem("showning");
    // if (data !== null) {
    //     $("input[name='switch_show']").attr("checked", "checked");
    // }
    // if ($(this).is(":checked")) {
    //     localStorage.setItem("showning", 1);
    // } else {
    //     localStorage.removeItem("showning");
    // }
  }
  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
    this.UserType = null;
    this.router.navigate(['/login']);
  }

  openDialog(content?: any): void {
    const dialogRef = this.dialog.open(CMSContentComponent, {
      width: '500px',
      data: content ? { content: content } : null,
    });
  }
  navigateToDashboard() {
    if (!this.isLoggedIn || !this.authService.isTokenValid()) {
      this.router.navigate(['/login']);
      return;
    }
    switch (this.UserType) {
      case 1: // Admin
        this.router.navigate(['/admin/dashboard']);
        break;
      case 2: // Customer
        this.router.navigate(['/homepage']);
        break;
      case 3: // Firm
        this.router.navigate(['/dashboard']);
        break;
      case 4: // Agent
        this.router.navigate(['/agent-dashboard']);
        break;
      case 5: // Partner
        this.router.navigate(['/partner/dashboard']);
        break;
      default:
        this.router.navigate(['/']);
        break;
    }
  }

  private checkUrl() {
    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    this.isRootUrl = baseUrl === '/' || baseUrl === '';
    this.hideAgentDemoButton =
      baseUrl === '/all-state-agency' || baseUrl === '/customer-agent-profile';
  }

  HelpPage() {
    this.router.navigate(['faq-page']);
  }

  getNotificationList() {
    const obj = {
      pageNumber: 1,
      pageSize: 3,
      orderBy: '',
      sortOrder: '',
      search: '',
    };
    const apiUrl = this.url.apiUrl.notification.getNotificationList;

    this.apiservice.doPost(apiUrl, obj).subscribe({
      next: (data) => {
        if (data.Success) {
          this.NotificationList = data.Data;
          this.notificationCount =
            this.NotificationList.length > 0
              ? this.NotificationList[0]?.UnreadCount
              : 0;
        }
      },
      error: () => {
        this.spinner.hide();
        this.spinner.hide();
      },
    });
  }

  getNotificationLength(event: any) {
    this.getNotificationList();
  }

  toggleLanguage(event: any) {
    const isChecked = event.target.checked;
    const selectedLang = isChecked ? 'eng' : 'spa';
    this.selectedLanguage = selectedLang;
    this.languageService.setLanguage(selectedLang);

    if(true == this.isLoggedIn){
      let apiUrl = this.url.apiUrl.account.savePreferLanguage;
      let email = this.storageService.getTokenData()?.Email;
      let objdata = {
        Email : email,
        PreferLanguage : selectedLang
      }

      this.apiservice.doPost(apiUrl,objdata).subscribe({
        next : (data) => {
          if(data && data.Success){
            // this.toastr.success(this.translate.instant(data.Message));
          }
        },
        error : (err) => {
         this.toastr.error(err.Message)
        }
      })
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.notificationPanel?.nativeElement.contains(
      event.target
    );
    const clickedBellIcon = (event.target as HTMLElement).closest(
      '.notification-wrapper'
    );

    if (!clickedInside && !clickedBellIcon) {
      this.showNotifications = false;
    }
  }
  isMenuOpen = false;

toggleMenu() {
  this.isMenuOpen = !this.isMenuOpen;
}
}
